<template>
  <transition name="modal-fade">
    <div class="modal-backdrop" style="padding: 1em;">
      <div class="modal"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription">
        <div class="modal-header" id="modalTitle" style="display:block;">
          <span style="font-weight: bolder; font-size: larger;">{{title}}</span>
          <span style="padding-left: 5em;"><font color="#621624;">關鍵字查詢：</font><el-input size="mini" class="input-205" placeholder="請輸入過濾條件" maxlength="200" tabindex="1" style="width:12em; padding: 0;"
                            v-model="partName"></el-input><span v-show="othersRows!=null && othersRows.length>0" style="float: right; font-size: xx-small; margin-top: 0.5em;">符合項目 (共{{(othersRows==null? 0: othersRows.length)}}筆)</span></span>
        </div>
        <div class="modal-body" id="modalDescription" style="padding:0.5rem">            
            <div style="padding: 0.25em 0.25em 1em;">
                <span>
                    <span class="pull-left" style="font-weight:bold;font-size:smaller;">選擇項目：</span>
                    <span style="background:#f7e8aa;">{{(currentData.length==0?'無':currentData)}}</span>
                <span style="float: right;">
                        <el-button type="success" tabindex="2" style="padding: 0.45rem 1rem;" @click="ok()">確定</el-button>
                        <el-button type="info" tabindex="3" style="padding: 0.45rem 1rem;" @click="cancel()">關閉</el-button>
                </span>
                </span>
            </div>
            <table class="ncut-table2-striped ncut-table2" style="font-size: 0.85rem; background: #FFFFFF; width:100%;">
                <thead class="ncut-thead2">
                    <tr style="border: 1px solid rgb(235, 238, 245);">
                        <th class="td-border" style="width: 2.75em;">項次</th>
                        <th class="td-border" style="width: 3em; ">代碼</th>
                        <th class="td-border" style="width: 16em;">名稱</th>
                        <th class="td-border" style="width: 2.75em;">項次</th>
                        <th class="td-border" style="width: 3em; ">代碼</th>
                        <th class="td-border" style="width: 16em;">名稱</th>
                        <th class="td-border" style="width: 2.75em;">項次</th>
                        <th class="td-border" style="width: 3em; ">代碼</th>
                        <th class="td-border" style="width: 16em;">名稱</th>
                    </tr>
                </thead>
                <tbody class="ncut-tbody2">
                    <tr v-for="(item, i) in filteredRows" :key="i"
                        style="border: 1px solid rgb(235, 238, 245);">
                        <td class="td-border" style=" color: gray; text-align: center;">
                            <a href="#" @click="setDataID(item.data[0])">
                                {{item.data[0].mailAddree}}
                            </a>
                        </td>
                        <td class="td-border" style="text-align: left;">
                            <a href="#" @click="setDataID(item.data[0])">
                                {{item.data[0].text1}}
                            </a>            
                        </td>
                        <td class="td-border" style="text-align: left;">
                            <a href="#" @click="setDataID(item.data[0])">
                                {{item.data[0].text2}}
                            </a>
                        </td>
                        <td class="td-border" style=" color: gray; text-align: center;"
                            v-if="item.max > 1">
                            <a href="#" @click="setDataID(item.data[1])">
                                {{item.data[1].mailAddree}}
                            </a>
                        </td>
                        <td class="td-border" style="text-align: left;"
                            v-if="item.max > 1">
                            <a href="#" @click="setDataID(item.data[1])">
                                {{item.data[1].text1}}
                            </a>            
                        </td>
                        <td class="td-border" style="text-align: left;"
                            v-if="item.max > 1">
                            <a href="#" @click="setDataID(item.data[1])">
                                {{item.data[1].text2}}
                            </a>
                        </td>
                        <td class="td-border" style=" color: gray; text-align: center;"
                            v-if="item.max > 2">
                            <a href="#" @click="setDataID(item.data[2])">
                                {{item.data[2].mailAddree}}
                            </a>
                        </td>
                        <td class="td-border" style="text-align: left;"
                            v-if="item.max > 2">
                            <a href="#" @click="setDataID(item.data[2])">
                                {{item.data[2].text1}}
                            </a>            
                        </td>
                        <td  class="td-border" style="text-align: left;"
                            v-if="item.max > 2">
                            <a href="#" @click="setDataID(item.data[2])">
                                {{item.data[2].text2}}
                            </a>
                        </td>
                    </tr>
                    <tr v-if="(0 == tableData.length)">
                        <td colspan="9" class="td-border" style="text-align: left;">無相關資訊</td>
                    </tr>
                </tbody>
            </table>
            <el-pagination :current-page="pageNo" :page-size="pageSize" layout=" prev, pager, next, jumper" :total="tableData.length"
                           @size-change="handleSizeChange" 
                           @current-change="handleCurrentChange"></el-pagination>
            <div>                
                <div class="dataTables_scrollBody" style="font-size: smaller; position: relative; overflow: auto; max-height: 8em; width: 100%; border-bottom: 1px solid #111; border-top: 1px solid #111;">
                    <el-card class="box-card" style="padding: 0 0.5rem;"  :body-style="{ padding: '0px' }">
                        <!-- <div slot="header">
                            <span>符合項目 (共{{(othersRows==null? 0: othersRows.length)}}筆)</span>
                        </div> -->
                        <div v-for="(item,index) in othersRows" :key="index" class="text item">
                            <a href="#" style="color:#732e12; " @click="setDataID(item)">{{item.text1}} {{item.text2}}</a>
                        </div>
                        <span v-show="othersRows==null || othersRows.length==0">無</span>
                    </el-card>
                </div>
            </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'optionView',
  props: [
    'title', 'mode', 'eId', 'sysId'
  ],
  data () {
    return {
      tableData: [],
      pageNo: 1,
      pageSize: 6,
      id: 0,
      currentData: '',
      partName:''
    }
  },
  computed: {
    filteredRows() { 
        var index = this.pageNo - 1;
        var start = (index * this.pageSize) + 1;
        var end = this.pageNo * this.pageSize;
        return (this.tableData.filter(function(d){ return d.id>=start && d.id<=end; }));
    }
    ,othersRows() {
        var ret = [];
        var tmpStr = this.partName.trim();
        if ((0 < this.tableData.length) && (0 < tmpStr.length)) {
            for (var i = 0; i < this.tableData.length; i++) {
                for (var j = 0; j < 3; j++) {
                    if ((this.tableData[i].data[j]!=null) && 
                        (this.tableData[i].data[j].text2).indexOf(tmpStr) > -1) {
                        ret.push(this.tableData[i].data[j]);
                    }
                }
            }
        }
        return ret;    
    }
  },
  methods: {
      handleSizeChange(val) {
        this.pageSize=val;
      },
      handleCurrentChange(val) {
        this.pageNo = val;
      },
      setDataID(item) {
        this.id = item.eId; 
        this.currentData = item.text1 + " "+ item.text2;
      },
      ok() {
        this.$store.dispatch('setOptionId', this.id);
        this.$store.dispatch('setOptionFlag', true);
        this.$emit('close');
      } ,
      cancel() {
        this.$store.dispatch('setOptionId', 0);
        this.$store.dispatch('setOptionFlag', false);
        this.$emit('close');
      } 
  },
  created () {
    console.log('======created OptionSelection=====');
    let vm = this
    this.$http        
        .get('./WebApi/Tools/GetOptionDataById/'.concat(this.sysId).concat('/').concat(this.mode))
        .then(function(response) {
            if (null != response.data) {
                vm.tableData = response.data;
              }
            })
            .catch(function (error) {
              vm.$message.error('對不起,網路連線失敗');
        });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
/* .modal 
{
    background-color: #fff;  
    transform: translate(0,0); 
    z-index: 1050; 
    width: 900px;
    display: block; 
    flex-direction: column; 
    position: relative;  
    -webkit-background-clip: padding-box;
    background-clip: padding-box;
    border: 1px solid #999;
    border: 1px solid rgba(0,0,0,.2);
    border-radius: 6px;
    outline: 0;
    -webkit-box-shadow: 0 3px 9px rgba(0,0,0,.5);
    box-shadow: 0 3px 9px rgba(0,0,0,.5);
}  
.btn-close 
{ 
    border: none 0; 
    font-size: 20px; 
    padding: 20px; 
    cursor: pointer; 
    font-weight: bold; 
    color: #4aae9b; 
    background-color: transparent; 
} 
.btn-green 
{ 
    color: #fff; 
    background-color: #4aae9b; 
    border: 1px solid #4aae9b; 
    border-radius: 2px; 
} */
.modal-backdrop 
{ 
    position: fixed; 
    top: 0; 
    right: 0; 
    bottom: 0; 
    left: 0; 
    background-color: rgba(0,0,0,.3); 
    display: flex; 
    justify-content: center; 
    align-items: center; 
} 
.modal { 
    background-color: #fff;  
    transform: translate(0,0); 
    z-index: 1050; 
    width: 900px;
    display: block; 
    flex-direction: column; 
    position: relative;  
    -webkit-background-clip: padding-box;
    background-clip: padding-box;
    border: 1px solid #999;
    border: 1px solid rgba(0,0,0,.2);
    border-radius: 6px;
    outline: 0;
    -webkit-box-shadow: 0 3px 9px rgba(0,0,0,.5);
    box-shadow: 0 3px 9px rgba(0,0,0,.5);
} 
.modal-header, .modal-footer { 
    padding: 15px; 
    display: flex; 
} 
.modal-header { 
    border-bottom: 1px solid #eee; 
    color: #4aae9b; 
    justify-content: space-between; 
} 
.modal-footer { 
    border-top: 1px solid #eee; 
    justify-content: flex-end; 
} 
.modal-body { 
    position: relative; 
    padding: 20px 10px; } 
    .btn-close { 
    border: none 0; 
    font-size: 20px; 
    padding: 20px; 
    cursor: pointer; 
    font-weight: 
    bold; color: #4aae9b; 
    background-color: transparent; 
} 
.td-border{
    text-align: center; 
    border-right: 1px solid #ebeef5; 
    border-bottom: 1px solid #ebeef5;
}
  .el-card__header {
    padding: 0 0.5rem;
    background: #D9D9D9;
  }
</style>



// WEBPACK FOOTER //
// src/components/OptionSelection.vue